<section class="mat-typography center main-heading">
  <br />
  <h1>Transactions By Source IP Report</h1>
</section>
@if (!loading) {
<div class="form-group padded-side-nav">
  @if (!resetHeader) {
<div class="search-bar">
    <app-generic-table-header
      [config]="headerOptions"
      (dropdownSelected)="groupSelect($event)"
      (viewPressed)="EnquireReportInfo()"
      (exportPressed)="downloadReport()"
      (clearPressed)="reset()"
      (dateRangeChange)="setDate($event)"></app-generic-table-header>
  </div>
}
  @if (!resetHeader) {
<div class="instructions mat-typography">
    Select a date range and group to begin report generation.
  </div>
}

  <br />
  <br />
  @if (!loading && reportResults != null && reportResults.length > 0) {
<div
    class="table">
    <div class="heading center mat-typography">
      Results
    </div>
    <app-card-table
      [data]="reportResults"
      [tableHeaders]="resultsHeaders"
      [options]="options"
      [enableInfiteScroll]="false"
      [enableTablePagination]="true"
      [enableRefresher]="false"
      [totalItems]="reportResults.length"
      [currentPage]="currentPage"
      (paginateEvent)="onPageChange($event)"
      [breakpoint]="ScreenSize.TABLET">
    </app-card-table>
    <br />
  </div>
}
</div>
}
@if (loading) {
<div class="flex-center">
  <mat-spinner></mat-spinner>
</div>
}
